import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

const CARDS = [
  {
    key: 'tasks',
    label: 'Tasks',
    icon: 'bi-check2-square',
    to: '/tasks',
    query: () => supabase.from('todos').select('id', { count: 'exact', head: true }).eq('status', 'pending'),
    format: n => ({ value: n, sub: 'pending' }),
  },
  {
    key: 'shopping',
    label: 'Shopping',
    icon: 'bi-cart3',
    to: '/shopping',
    query: () => supabase.from('shopping_items').select('id', { count: 'exact', head: true }).eq('archived', false).eq('checked', false),
    format: n => ({ value: n, sub: 'items remaining' }),
  },
  {
    key: 'thoughts',
    label: 'Thoughts',
    icon: 'bi-journal-text',
    to: '/thoughts',
    query: () => supabase.from('thoughts').select('created_at', { count: 'exact' }).order('created_at', { ascending: false }).limit(1),
    format: (n, data) => ({
      value: n,
      sub: data?.[0]?.created_at ? 'last: ' + new Date(data[0].created_at).toLocaleDateString() : 'no entries',
    }),
    useData: true,
  },
  {
    key: 'activities',
    label: 'Activities',
    icon: 'bi-lightning-charge',
    to: '/activities',
    query: () => supabase.from('activities').select('id', { count: 'exact', head: true }),
    format: n => ({ value: n, sub: 'total logged' }),
  },
  {
    key: 'workouts',
    label: 'Workouts',
    icon: 'bi-bicycle',
    to: '/workouts',
    query: () => supabase.from('workouts').select('date', { count: 'exact' }).order('date', { ascending: false }).limit(1),
    format: (n, data) => ({
      value: n,
      sub: data?.[0]?.date ? 'last: ' + new Date(data[0].date).toLocaleDateString() : 'no entries',
    }),
    useData: true,
  },
  {
    key: 'golf',
    label: 'Golf',
    icon: 'bi-trophy',
    to: '/golf',
    query: () => supabase.from('golf_rounds').select('id', { count: 'exact', head: true }),
    format: n => ({ value: n, sub: 'rounds played' }),
  },
  {
    key: 'health',
    label: 'Health',
    icon: 'bi-heart-pulse',
    to: '/health',
    query: () => supabase.from('health_metrics').select('created_at').order('created_at', { ascending: false }).limit(1),
    format: (n, data) => ({
      value: n,
      sub: data?.[0]?.created_at ? 'last: ' + new Date(data[0].created_at).toLocaleDateString() : 'no entries',
    }),
    useData: true,
  },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});

  useEffect(() => {
    async function loadStats() {
      const results = await Promise.all(
        CARDS.map(async card => {
          if (card.useData) {
            const { data, count, error } = await card.query();
            if (error) return [card.key, { value: '—', sub: '' }];
            return [card.key, card.format(count ?? 0, data)];
          } else {
            const { count, error } = await card.query();
            if (error) return [card.key, { value: '—', sub: '' }];
            return [card.key, card.format(count ?? 0)];
          }
        })
      );
      setStats(Object.fromEntries(results));
    }
    loadStats();
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Your personal overview</p>
      </div>

      <div className="stat-grid">
        {CARDS.map(card => {
          const stat = stats[card.key];
          return (
            <div key={card.key} className="stat-card" onClick={() => navigate(card.to)}>
              <div className="stat-card-icon"><i className={`bi ${card.icon}`} /></div>
              <div className="stat-card-label">{card.label}</div>
              <div className="stat-card-value">{stat ? stat.value : '…'}</div>
              <div className="stat-card-sub">{stat ? stat.sub : ''}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
